export const FormTableOfContentsSectionStat = Backbone.Model.extend({
    /**
     * @author:david We could infer many of these values from others, but it seems a little clearer to be explicit.
     */
    defaults: {
        is_sectionless_section: false, // should be set to true if this 'section' does not have an actual section field
        // (this is often the first 'section' of a form)
        section: null, // This may be null if the above is true
        num_total: 0,
        num_complete: 0,
        num_incomplete: 0,
        num_optional: 0,
        num_optional_complete: 0,
        num_optional_incomplete: 0,
        num_required: 0,
        num_required_complete: 0,
        num_required_incomplete: 0,
        nesting_level: 0
    },

    /**
     * Increment a model value by 1.
     */
    plus_plus: function (attr) {
        if (typeof this.get(attr) === 'undefined') {
            return this.set(attr, 1);
        }
        this.set(attr, this.get(attr) + 1);
    }
});

export const FormTableOfContentsSectionStats = Backbone.Collection.extend({
    model: FormTableOfContentsSectionStat
});
